import { Trade } from '@root/entities/trade'

import type { WalletsTrackerGetAlertsListData } from '@blade/trade-api-client'
import type { PairModel } from '@root/entities/pair'
import type { AvatarsHost } from '@root/shared/models'
import type { TokenLogosHost } from '@root/shared/models/TokenLogosHost'

export interface Alert extends Trade.Trade {
  pair: PairModel | undefined
}

export const fromDto = (
  dto: WalletsTrackerGetAlertsListData['data'][number],
  tokenLogosHost: TokenLogosHost,
  avatarsHost: AvatarsHost,
  pair: PairModel | undefined,
): Alert => {
  const trade = Trade.fromDto(dto, tokenLogosHost, avatarsHost)
  return {
    ...trade,
    quoteCurrency: pair?.quote ?? trade.quoteCurrency,
    pair,
  }
}
